import { CommonModule } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WorkflowLandingComponent } from "../../workflow/workflow-landing/workflow-landing.component";
import { UserLandingComponent } from "../../user/user-landing/user-landing.component";
import { RoleLandingComponent } from "../../role/role-landing/role-landing.component";
import { LgaSettingsLandingComponent } from "../../lga-settings-landing/lga-settings-landing.component";
import { AuthenticationService } from '../../../modules/services/authentication.service';

@Component({
  selector: 'app-setting-landing',
  standalone: true,
  imports: [CommonModule, FormsModule, WorkflowLandingComponent, UserLandingComponent, RoleLandingComponent, LgaSettingsLandingComponent],
  templateUrl: './setting-landing.component.html',
  styleUrl: './setting-landing.component.scss'
})
export class SettingLandingComponent {

  activeTab = 'workflow';
  searchQuery = '';
  openMenuIndex: number | null = null;

  tabs = [
    { key: 'workflow', label: 'Workflow', roles: ['ADMIN', 'MDA_ADMIN']},
    { key: 'users', label: 'User Management', roles: ['ADMIN'] },
    { key: 'roles', label: 'Role Management', roles: ['ADMIN'] },
    { key: 'mda', label: 'MDA Settings', roles: ['ADMIN', 'MDA_ADMIN'] },
  ];

  authService: AuthenticationService = inject(AuthenticationService);

  constructor() {}

  ngOnInit(): void {
  }

  setActiveTab(tab: string): void {
    this.activeTab = tab;
    this.openMenuIndex = null;
  }

  getTabClass(tab: string): string {
    if (tab === this.activeTab) {
      return 'bg-vms-bg-secondary text-vms-text-secondary shadow-sm';
    }
    return 'text-slate-500 hover:text-slate-700 hover:bg-slate-100';
  }

  getStatusClass(status: string): string {
    if (status === 'Active') {
      return 'bg-emerald-50 text-emerald-700 border border-emerald-200';
    }
    return 'bg-slate-100 text-slate-500 border border-slate-200';
  }


  toggleMenu(index: number): void {
    this.openMenuIndex = this.openMenuIndex === index ? null : index;
  }

  openCreateModal(): void {
    // In production: open a dialog/modal service
    console.log('Open Create Workflow modal');
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.openMenuIndex = null;
  }
}
